import { Calendar } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Pages whose own hero booking button sits where this floating button would cover it on phones.
const HIDE_ON_MOBILE = ["/extend", "/authority-engine"];

const FloatingCTA = () => {
  const { pathname } = useLocation();
  const hideOnMobile = HIDE_ON_MOBILE.includes(pathname);

  return (
    <a
      href="https://meetings.series-a.co/meetings/series-a/authorpro"
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "fixed bottom-6 right-6 z-50 flex-col items-center gap-2 group",
        hideOnMobile ? "hidden sm:flex" : "flex"
      )}
    >
      <span className="text-xs font-semibold uppercase tracking-[0.15em] text-foreground bg-card/95 backdrop-blur-sm px-3 py-1.5 rounded-full border border-border shadow-lg whitespace-nowrap">
        Book a Call
      </span>
      <Button
        size="icon"
        aria-label="Book a call"
        className="w-14 h-14 rounded-full shadow-lg bg-gold text-gold-foreground hover:bg-gold-light transition-all duration-300 hover:scale-110"
        style={{ animation: "bounce 4s ease-in-out infinite" }}
      >
        <Calendar className="w-6 h-6" />
      </Button>
    </a>
  );
};

export default FloatingCTA;
